import { render, staticRenderFns } from "./ProductsEntity.vue?vue&type=template&id=18ad86f2&"
import script from "./ProductsEntity.vue?vue&type=script&lang=js&"
export * from "./ProductsEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports